module.exports = __webpack_public_path__ + "img/b_12_s.ef61b446.jpg";